import { ContactFormInterface } from '@/modules/contacts/shared/domain/contact-form.interface';

export const CONTACT_FORM_EMPTY: ContactFormInterface = {
    contactId: -1,
    userId: -1,
    name: '',
    lastName: '',
    nationality: 'V',
    ci: '',
    position: '',
    email: '',
    phone: '',
    cellphone: '',
    data: [],
    userStatus: {
        id: -1,
        name: '',
    },
    password: '',
    contactType: {
        id: -1,
        name: '',
    },
    scalabilityLevel: {
        id: -1,
        name: '',
    },
    priority: -1,
    confirmationPassword: '',
    contactRoles: [],
    sgcResources: [],
};
